import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

const api3000 = axios.create({
    baseURL: process.env.REACT_APP_API_3000_URL,
});

setupInterceptors(api3000);

export default api3000;
